<script setup lang="ts">
import AnyIcon from '@/core/elements/AnyIcon.vue';
import { getSubjectTintStyle } from '@/utils/color.utils';
import { computed } from 'vue';

type TCompetenceDomainIconSize = 'xs' | 'sm' | 'print-sm' | 'print-md' | 'md' | 'lg';

const props = withDefaults(
  defineProps<{
    color?: string;
    iconName: string;
    size?: TCompetenceDomainIconSize;
  }>(),
  {
    color: undefined,
    size: 'md',
  },
);

const tintStyle = computed<Record<string, string> | undefined>(() => getSubjectTintStyle(props.color));

const containerSizeClass: Record<TCompetenceDomainIconSize, string> = {
  xs: 'size-[22px]',
  sm: 'size-6',
  'print-sm': 'size-[26px]',
  'print-md': 'size-[30px]',
  md: 'size-icon-button',
  lg: 'size-button',
};

const iconSizeClass: Record<TCompetenceDomainIconSize, string> = {
  xs: 'size-icon-xs',
  sm: 'size-3.5',
  'print-sm': 'size-icon-xs',
  'print-md': 'size-icon-xs',
  md: 'size-icon-sm',
  lg: 'size-icon-md',
};
</script>

<template>
  <span
    :class="[
      'flex shrink-0 items-center justify-center rounded-button border border-white bg-surface-primary text-secondary',
      containerSizeClass[props.size],
    ]"
    :style="tintStyle"
    aria-hidden="true"
  >
    <AnyIcon :icon-name="props.iconName" :class="iconSizeClass[props.size]" />
  </span>
</template>
